import React from 'react';
import PropTypes from 'prop-types';
import BaseInputValidationComponent from './BaseInputValidationComponent';

class WbmForm extends React.PureComponent {
    constructor(props, context) {
        super(props, context);
        this.submit = this.submit.bind(this);
        this.onValidate = this.onValidate.bind(this);

        this.state = {
            formIsValid: false,
            validationErrors: []
        };
    }

    onValidate(inputName, isValid, validationErrors) {
        let isValidationForChildComponentInObj = false;
        let updatedValidationErrArray = this.state.validationErrors.map(x => {
            if (x.inputName === inputName) {
                x = { inputName, isValid, validationErrors };
                isValidationForChildComponentInObj = true;
            }
            return x;
        });

        if (!isValidationForChildComponentInObj) {
            updatedValidationErrArray.push({ inputName: inputName, isValid: validationErrors.length === 0, validationErrors: validationErrors });
        }

        if (this.props.onFormValidation) {
            let childrenWithErrors = this.getChildrenWithErrors();
            this.props.onFormValidation(childrenWithErrors.length === 0, this.state.validationErrors);
        }

        this.setState({ validationErrors: updatedValidationErrArray, formIsValid: !updatedValidationErrArray.some(x => !x.isValid) });
    }

    getChildrenWithErrors() {
        return this.state.validationErrors.filter(validationObject => validationObject.validationErrors.length > 0);
    }

    submit(event) {
        event && event.preventDefault();
        if (this.state.formIsValid) {
            if (this.props.onSubmit) {
                this.props.onSubmit();
            }
        }
        else {
            if (this.props.onError) {
                let childrenWithErrors = this.getChildrenWithErrors();
                this.props.onError(childrenWithErrors.length === 0, childrenWithErrors);
            }
        }
    }

    mapFormValidationUpdaterToChildren() {
        const isChildABaseInputComponent = (child) => BaseInputValidationComponent.isPrototypeOf(child.type) || typeof child.type !== "string";

        return React.Children.map(this.props.children, child =>
            isChildABaseInputComponent(child) ? React.cloneElement(child, { updateFormOnValidation: this.onValidate }) : child);
    }

    render() {
        let { submit, children, onError, onFormValidation, ...rest } = this.props;
        const childrenWithProps = this.mapFormValidationUpdaterToChildren();

        return <form {...rest} onSubmit={this.submit}>
            {childrenWithProps}
        </form>;
    }
}

WbmForm.propTypes = {
    /** callback that triggers if onSubmit is called on the form(either via submit button or enter key) AND form is valid */
    onSubmit: PropTypes.func.isRequired,
    /**
     * A collection of inputs 
     * uncontrolled "input" DOM elements may be used but their state will be ignored
     * please use a component that inherits from @type {BaseInputValidationComponent}
     */
    children: PropTypes.node,
    /** callback that triggers on a form validation event - this event occurs upon validation of a child input component (usually onChange)
     * @param {isFormValid} bool
     * @param {validationErrors} array an array of ALL react children nodes and their validation info, regardless of validation status
     */
    onFormValidation: PropTypes.func,
    /** callback that triggers if form is not valid during onSubmit event 
     * @param {isFormValid} bool
     * @param {validationErrors} array an array of strictly invalid react children node validation info/error messages
     */
    onError: PropTypes.func
};

export default WbmForm;
